
import {setServer} from "@/utils/axios";
const request = setServer();
// 查询站点列表
export function getPlatformSettingList(data) {
  return request({
    url: '/base/platform/setting/list' ,
    method: 'post',
    data:data
  })
}

// 查询站点详情
export function getSiteDetail(data) {
  return request({
    url: '/base/platform/setting/get' ,
    method: 'post',
    data:data
  })
}
// 新增站点
export function addSite(data) {
  return request({
    url: '/base/platform/setting/add' ,
    method: 'post',
    data:data
  })
}

// 修改站点
export function updateSite(data) {
  return request({
    url: '/base/platform/setting/update' ,
    method: 'post',
    data:data
  })
}

// 删除站点
export function deleteSite(data) {
  return request({
    url: '/base/platform/setting/delete' ,
    method: 'post',
    data:data
  })
}

// 获取站点设置
export function getSiteSetting(data) {
  return request({
    url: '/base/platform/setting/get-one' ,
    method: 'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/base/platform.js